export default __webpack_public_path__ + "static/all_counterfeit_locations-c1443564523efddefc39db8c67198b45.png";